import sdl from '@jds/react-generated-sdl/TestComponent';
import type { TestComponentProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: TestComponentProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { kind = 'NORMAL', custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { kind, ...rest },
    'TestComponent',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const TestComponent = withLogic(Component) as React.FC<TestComponentProps> & {
  slotName?: string;
};

TestComponent.displayName = 'TestComponent';
TestComponent.slotName = 'test_component';

export { TestComponent, type TestComponentProps };
